import React, { useContext, useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Logo from "../../assets/logo.png";
import { UserContext } from "../../context/UserContext";
import { Avatar, Chip, Menu, MenuItem } from "@mui/material";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
	Settings,
	DeviceMobileOff,
	Businessplan,
	Power,
} from "tabler-icons-react";

const colors = [
	"#FF5733", // Soft red
	"#33A1FF", // Light blue
	"#00d726", // Light green
	"#FF33A1", // Pink
	"#FF8C33", // Orange
	"#FFC133", // Yellow
	"#8D33FF", // Purple
	"#33FFDA", // Turquoise
];

export default function Header({
	drawerWidth,
	handleDrawerToggle,
	onboardingFinished,
}) {
	const { user, setUser } = useContext(UserContext);
	const [anchorEl, setAnchorEl] = useState(null);
	const navigate = useNavigate();
	const { t } = useTranslation();

	const getColorFromStatus = (status) => {
		switch (status) {
			case "inviting":
				return "#f1c40f";
			case "building":
				return "#3498db";
			case "built":
				return "#43BD98";
			case "rejected":
				return "#e74c3c";
			case "publishing":
				return "#3498db";
			case "published":
				return "#43BD98";
			default:
				return "#f1c40f";
		}
	};

	const location = useLocation();

	useEffect(() => {
		if (onboardingFinished) {
			setUser({ ...user, finishOnboarding: true });
			navigate("/");
		}
	}, [onboardingFinished]);

	useEffect(() => {
		ReactGA.send({
			hitType: "pageview",
			page: window.location.href,
			title: "",
		});
	}, [location]);

	const userName = user?.name
		?.split(" ")
		.map((name) => name[0])
		.join("")
		.slice(0, 3)
		.toUpperCase();

	const getColorIndex = (name) => {
		let hash = 0;
		for (let i = 0; i < name.length; i++) {
			hash = name.charCodeAt(i) + ((hash << 5) - hash);
		}
		return Math.abs(hash) % colors.length;
	};

	const backgroundColor = colors[getColorIndex(userName)];

	// Open the menu
	const handleMenuOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	// Close the menu
	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	// Navigate to a specific route and close the menu
	const handleNavigation = (path) => {
		navigate(path);
		handleMenuClose();
	};

	return (
		<Box sx={{ flexGrow: 1 }}>
			<AppBar
				color="secondary"
				elevation={0}
				position="fixed"
				sx={{
					width: {
						sx: "100%",
						sm: `calc(100% - ${drawerWidth}px)`,
						ml: `${drawerWidth}px`,
					},
				}}
			>
				<Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
					<Box sx={{ display: "flex", alignContent: "center" }}>
						<IconButton
							color="inherit"
							aria-label="open drawer"
							edge="start"
							onClick={handleDrawerToggle}
							sx={{ mr: 2, display: { sm: "none" } }}
						>
							<MenuIcon sx={{ color: "#262626" }} />
						</IconButton>

						<img src={Logo} alt="logo" style={{ width: 90 }} />
					</Box>

					<Box sx={{ display: "flex", gap: 2 }}>
						<Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
							<Typography
								sx={{ fontSize: 12, display: { xs: "none", sm: "block" } }}
							>
								{t("publish.appStatus") || ""}
							</Typography>
							<Chip
								label={t(
									"publish." +
										(user.app.appStatuses[0]?.status ?? "pending") +
										"Status"
								)}
								onClick={() => {
									navigate("/publish");
								}}
								sx={{
									backgroundColor: getColorFromStatus(
										user.app.appStatuses[0]?.status
									),
									color: "white",
									borderRadius: "30px",
									cursor: "pointer!important",
									"&:hover": {
										backgroundColor: getColorFromStatus(
											user.app.appStatuses[0]?.status
										),
										textDecoration: "underline",
									},
								}}
							></Chip>
						</Box>
						<Box>
							<Avatar
								src={user?.avatar}
								alt={user?.name}
								sx={{
									width: 32,
									height: 32,
									fontSize:
										userName.length === 3
											? 10
											: userName.length === 2
											? 14
											: "inherit",
									backgroundColor: backgroundColor,
									cursor: "pointer",
								}}
								onClick={handleMenuOpen}
							>
								{userName}
							</Avatar>
							<Menu
								anchorEl={anchorEl}
								keepMounted
								open={Boolean(anchorEl)}
								onClose={handleMenuClose}
							>
								<MenuItem
									onClick={() => handleNavigation("/settings")}
									sx={{ fontSize: "12px" }}
								>
									<Settings size={18} style={{ marginRight: "8px" }} />{" "}
									{t("menu.profile")}
								</MenuItem>
								<MenuItem
									sx={{ fontSize: "12px" }}
									onClick={() => handleNavigation("/plans")}
								>
									<Businessplan size={18} style={{ marginRight: "8px" }} />{" "}
									{t("menu.plans")}
								</MenuItem>

								<MenuItem
									sx={{ fontSize: "12px" }}
									onClick={() => {
										localStorage.removeItem("token");
										try {
											window.Tawk_API.logout(function (error) {
												// do something if error
											});
										} catch (error) {
											console.log(error);
										}
										window.location.reload();
									}}
								>
									<Power size={18} style={{ marginRight: "8px" }} />
									{t("menu.logout")}
								</MenuItem>
							</Menu>
						</Box>
					</Box>
				</Toolbar>
			</AppBar>
		</Box>
	);
}
